// Convierte número de Excel → Date JS
export const excelFloatToDate = (value) => {
  if (value === '' || value == null || Number.isNaN(value)) return null;
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  const millis = value * 24 * 60 * 60 * 1000;
  return new Date(excelEpoch.getTime() + millis);
};

// Formatea hora con AM/PM + 24h
export const formatTime = (date) => {
  if (!date || Number.isNaN(date.getTime())) return '';
  const h = date.getUTCHours();
  const m = date.getUTCMinutes();
  const s = date.getUTCSeconds();
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

// Formatea lapso en HH:MM:SS
export const formatLapse = (startDate, endDate) => {
  if (!startDate || !endDate || Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return '';
  let diff = (endDate - startDate) / 1000;
  if (diff < 0) diff += 24 * 60 * 60;
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = Math.floor(diff % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

// Nombre del día
export const getDayName = (date) => {
  if (!date || Number.isNaN(date.getTime())) return '';
  const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  return days[date.getUTCDay()];
};

// Formatea fecha DD/MM/YYYY
export const formatDate = (date) => {
  if (!date || Number.isNaN(date.getTime())) return '';
  const d = date.getUTCDate();
  const m = date.getUTCMonth() + 1;
  const y = date.getUTCFullYear();
  return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`;
};

// Formatea fecha YYYY/MM/DD
export const formatDateYYYYMMDD = (date) => {
  if (!date || Number.isNaN(date.getTime())) return '';
  const d = date.getUTCDate();
  const m = date.getUTCMonth() + 1;
  const y = date.getUTCFullYear();
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
};
